export default __webpack_public_path__ + "static/media/unionpay.b454a4fd.svg";